import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import apiClient from "../utils/apiClient";
import InputBlock from "../components/InputBlock";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../features/user/userSlice";
import { Alert, Button, TextField } from "@mui/material";
import PageTitle from "../components/PageTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const Container = styled.form`
  max-width: 450px;
`;

const ChangePasswordPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  const [passNow, setPassNow] = useState("");
  const [passNew, setPassNew] = useState("");
  const [passNewTwo, setPassNewTwo] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePassword = async () => {
    setError("");
    try {
      setIsLoading(true);
      const response = await apiClient.post("/agents/changepassword", {
        pass_now: passNow,
        pass_new: passNew,
        pass_new_two: passNewTwo,
      });

      if (response.data.error) {
        if (response.data.error_type === "notequal") {
          setError(t("changePassword.errors.notEqual"));
        } else if (response.data.error_type === "strlen") {
          setError(t("changePassword.errors.tooShort"));
        } else if (response.data.error_type === "pass_now") {
          setError(t("changePassword.errors.currentPasswordWrong"));
        } else {
          setError(t("changePassword.errors.unknown"));
        }
      } else {
        if (response.data.token) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user", JSON.stringify(response.data.user));
          dispatch(setUser(response.data.user));
        }

        alert(t("changePassword.success"));
        navigate("/panel");
      }
    } catch (err) {
      console.error(err);
      const responseError = err?.response?.data;
      setError(
        responseError?.message ??
          (typeof responseError?.error === "string"
            ? responseError.error
            : t("changePassword.errors.changeFailed")),
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <Helmet>
        <title>{t("changePassword.metaTitle")}</title>
        <meta
          name="description"
          content={t("changePassword.metaDescription")}
        />
      </Helmet>

      <PageTitle>{t("changePassword.title")}</PageTitle>

      <p>{t("changePassword.requirementsTitle")}</p>

      <ul style={{ fontSize: "14px" }}>
        <li>{t("changePassword.requirements.lettersAndDigits")}</li>
        <li>{t("changePassword.requirements.upperAndLower")}</li>
        <li>{t("changePassword.requirements.minLength")}</li>
        <li>{t("changePassword.requirements.notUsedBefore")}</li>
        <li>{t("changePassword.requirements.specialChars")}</li>
      </ul>

      <input
        id="username"
        type="email"
        value={user.login}
        disabled
        autoComplete="username"
        style={{ display: "none" }}
      />

      <InputBlock style={{ marginBottom: 10 }}>
        <p>{t("changePassword.currentPassword")}</p>
        <TextField
          size="small"
          fullWidth
          type="password"
          autoComplete="current-password"
          value={passNow}
          onChange={(e) => setPassNow(e.target.value)}
          placeholder={t("changePassword.currentPassword")}
          disabled={isLoading}
        />
      </InputBlock>

      <InputBlock style={{ marginBottom: 10 }}>
        <p>{t("changePassword.newPassword")}</p>
        <TextField
          size="small"
          fullWidth
          type="password"
          autoComplete="new-password"
          value={passNew}
          onChange={(e) => setPassNew(e.target.value)}
          placeholder={t("changePassword.newPassword")}
          disabled={isLoading}
        />
      </InputBlock>

      <InputBlock style={{ marginBottom: 10 }}>
        <p>{t("changePassword.repeatNewPassword")}</p>
        <TextField
          size="small"
          fullWidth
          type="password"
          autoComplete="new-password"
          value={passNewTwo}
          onChange={(e) => setPassNewTwo(e.target.value)}
          placeholder={t("changePassword.repeatNewPasswordPlaceholder")}
          disabled={isLoading}
        />
      </InputBlock>

      {error && <Alert severity="error">{error}</Alert>}

      <Button
        variant="contained"
        color="primary"
        onClick={handleChangePassword}
        fullWidth
        sx={{ my: 2 }}
        disabled={isLoading}
      >
        {t("changePassword.submit")}
      </Button>
    </Container>
  );
};

export default ChangePasswordPage;
